"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitCamelCase = splitCamelCase;
exports.parseJSON = parseJSON;
/* eslint import/prefer-default-export: "off" */

function splitCamelCase(s) {
  return s.replace(/([a-z])([A-Z])/g, '$1 $2');
}
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON, status from the response
 */


function parseJSON(response) {
  return new Promise(function (resolve, reject) {
    return response.json().then(function (json) {
      return resolve({
        status: response.status,
        ok: response.ok,
        json: json
      });
    }).catch(function () {
      return reject(response);
    });
  });
}